// not for translation =================>

import { apiRequest } from "../util/apiUtils";

export const languageList = async (payload) => {
  try {
    const res = await apiRequest("get", "language/list", {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
